export const getters = {
  getUiFlags: $state => $state.uiFlags,
  getSummary: $state => $state.summary,
  getSentiment: $state => $state.sentiment,
  getEngagement: $state => $state.engagement,
  getCompetitors: $state => $state.competitors,
  getTopMentioners: $state => $state.topMentioners,
  getMentions: $state => $state.mentions,
  getProfiles: $state => $state.profiles,
  getSettings: $state => $state.settings,
  getPoliticalInsights: $state => $state.politicalInsights,
  getPublicReaction: $state => $state.publicReaction,
  getPublicReactionAnalysis: $state => $state.publicReactionAnalysis,
  getTopics: $state => $state.topics,
  getReports: $state => $state.reports,
  getCurrentReport: $state => $state.currentReport,
  getClusters: $state => $state.clusters,
  getAlerts: $state => $state.alerts,
  getAlertsUnreadCount: $state => $state.alertsUnreadCount,
  getContentBreakdown: $state => $state.contentBreakdown,
  getConversionIndices: $state => $state.conversionIndices,
  getNarratives: $state => $state.narratives,
  getEmotionBreakdown: $state => $state.emotionBreakdown,
  getContentSuggestions: $state => $state.contentSuggestions,
  getResponseLibrary: $state => $state.responseLibrary,
  getCopilot: $state => $state.copilot,
  getTerritorialBreakdown: $state => $state.territorialBreakdown,
  getDemographicBreakdown: $state => $state.demographicBreakdown,
  getTerritorialSegmentation: $state => $state.territorialSegmentation,
};
